import { css } from 'linaria';

export const formStyles = css`
	display: flex;
	flex-direction: column;
	gap: 32px;
	margin-bottom: 24px;
	background: var(--background-primary);
	button {
		padding: 12px 24px;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.05px;
		color: var(--text-primary-invert);
		background: #464c5c;
		border-radius: 8px;
	}

	span {
		color: var(--text-minor);
	}
`;
export const sendBtn = css`
	background: var(--text-primary) !important;
`;
